export const shadowPalette = {
  "1dp": "0px 0px 16px rgba(0, 0, 0, 0.12)",
} as const;

export type ShadowPalette = `shadow.${keyof typeof shadowPalette}`;
